import { formatSort } from 'helper';
import { req } from 'react-reqq-lite';
import { toastSuccess } from 'react-geek-toast';
import { FILTER, ITEM, LIST, PAGER } from './constants';
import { transformList } from './transformers';

export const listCategory = (params) => {
  req.get({
    key: LIST,
    url: '/admin/game_mng/v1/category',
    params: formatSort(params),
    transform: (res) => (res?.data || []).map(transformList),
    onSuccess: (res) => {
      req.set(FILTER, params);
      req.set(PAGER, res?.response?.meta || {});
    },
  });
};

export const createCategory = (payload, onSuccess) => {
  req.post({
    key: ITEM,
    url: '/admin/game_mng/v1/category',
    payload,
    onSuccess: (state) => {
      setTimeout(() => {
        listCategory(state[FILTER]);
      }, 1000);
      toastSuccess('Added!');
      onSuccess();
    },
  });
};

export const updateCategory = (id, payload, onSuccess) => {
  req.put({
    key: ITEM,
    url: `/admin/game_mng/v1/category/${id}`,
    payload,
    onSuccess: (state) => {
      setTimeout(() => {
        listCategory(state[FILTER]);
      }, 1000);
      toastSuccess('Updated!');
      onSuccess();
    },
  });
};

export const deleteCategory = (id, onSuccess) => {
  req.remove({
    key: ITEM,
    url: `/admin/game_mng/v1/category/${id}`,
    onSuccess: (state) => {
      setTimeout(() => {
        listCategory(state[FILTER]);
      }, 1000);
      toastSuccess('Deleted!');
      onSuccess();
    },
  });
};
